<template>
  <div id="login" style="min-height: 100vh; background-color: #ffffff!important;">
    <b-row class="justify-content-center no-gutters">
      <b-col lg="12" class="d-flex align-items-center">
        <b-card no-body class="w-100">
          <b-row class="no-gutters" style="min-height: 80vh">
            <b-col md="16" lg="6" class="bg-primary-sub1 d-md-flex align-items-center justify-content-center"
                   style="min-width:50vh">
              <b-img fluid src="images/sliderbg/letters.png"/>
            </b-col>
            <b-col
                lg="6"
                class="d-md-flex align-items-center justify-content-center"
            >
              <div class="d-flex align-items-center w-100">
                <div class="p-5 w-100">
                  <b-row class="justify-content-center">
                    <b-row class="justify-content-center">
                      <b-col cols="12" class="pl-lg-5 pr-lg-5">
                        <div>
                          <p class="font-weight-normal text-center"
                             v-html="getCaptions('LABEL_LOGIN_GLOBAL_MESSAGE_APP')"/>
                          <p class="font-weight-normal text-center"/>
                        </div>
                      </b-col>
                    </b-row>
                    <b-col cols="12" class="pt-5">
                      <div class="text-center pb-4"><span v-html="getCaptions('LABEL_LOGIN_TITLE')"/></div>
                      <b-container style="width: 490px">
                        <b-row class="pb-5 d-md-flex align-items-center justify-content-center">
                          <h2 class="font-weight-bold mt-4">Σύνδεση</h2>
                          <b-form class="w-75">
                            <b-input-group class="mt-3 border border-primary-sub1">
                              <template #prepend>
                                <b-input-group-text class="bg-primary-sub1"><i class="fa fa-user text-white"/>
                                </b-input-group-text>
                              </template>
                              <b-form-input
                                  id="txt-username"
                                  type="text"
                                  placeholder="Όνομα χρήστη taxisnet"
                                  v-model="$v.form.username.$model"
                                  @keydown.enter="onLogin"
                              ></b-form-input>
                            </b-input-group>
                            <b-input-group class="mt-3  border border-primary-sub1">
                              <template #prepend>
                                <b-input-group-text class="bg-primary-sub1"><i class="fa fa-lock text-white"/>
                                </b-input-group-text>
                              </template>
                              <b-form-input
                                  id="txt-pwd"
                                  type="password"
                                  placeholder="Κωδικός taxisnet"
                                  v-model="$v.form.pwd.$model"
                                  @keydown.enter="onLogin"
                              />
                            </b-input-group>
                            <b-button
                                v-on:click="onLogin"
                                variant="primary-sub1"
                                block
                                class="mt-3 text-white"
                                :disabled="isDisabled"
                            >Είσοδος<i class="fa fa-sign-in-alt ml-2 text-white"/>
                            </b-button
                            >
                          </b-form>
                        </b-row>

                      </b-container>

                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-card-footer class="text-center font-10 mt-2" style="min-height: 8vh; background-color: white">
<!--            Για την είσοδο απαιτείται η χρήση των προσωπικών κωδικών taxisnet του/της υπόχρεου:-->
<!--            <br>-->
<!--            <a target="_blank" rel="noopener noreferrer" class="text-primary font-italic font-weight-bold"-->
<!--               href="https://www1.gsis.gr/registration/chooseRegistrationType.htm">Eφαρμογή Κλειδάριθμος (ΑΑΔΕ)</a>-->
<!--            <br>Για οδηγίες απόκτησης βλέπε: <a target="_blank" rel="noopener noreferrer"-->
<!--                                                class="text-primary font-italic font-weight-bold"-->
<!--                                                href="https://www.gsis.gr/sites/default/files/POTHEN/Taxisnet_registraton.pdf">Διαδικασία-->
<!--            απόκτησης κωδικών πρόσβασης στην εφαρμογή TAXISnet</a>-->
          </b-card-footer>
        </b-card>
      </b-col>
      <footer class="p-4 text-center align-items-center justify-content-center">
        Copyright © {{ new Date().getFullYear() }} — Πόθεν Έσχες
      </footer>
    </b-row>
  </div>
</template>

<script>
import {validationMixin} from "vuelidate";
import {minLength, required} from "vuelidate/lib/validators";
import {makeToast, toggleBusy} from "@/util/ComponentUtils";
import {getCaption, isEmpty} from "@/util/Helpers";
import AuthServices from "@/service/AuthServices";
import Footer from "@/layouts/full-layout/footer/Footer.vue";

export default {
  name: "FullLogin",
  components: {Footer},
  mixins: [validationMixin],
  data: () => ({
    isBusy: false,
    form: {
      username: "",
      pwd: "",
    },
    checkbox: false,
  }),
  computed: {
    isDisabled() {
      return isEmpty(this.$v.form.pwd.$model) || isEmpty(this.$v.form.username.$model)
    },
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(1),
      },
      pwd: {
        required,
        minLength: minLength(1),
      },
    },
  },
  async created() {
    await toggleBusy(true)
    try {
      AuthServices.isAuthenticated().then(async (response) => {
        if (response.status === 200) {
          await this.$store.dispatch("auth/updateAuth", {
            auth: response.data.content,
            isAuthenticated: !isEmpty(response.data?.content[0]?.t002Id)
          });

          if (!isEmpty(this.$store.getters['auth/getT002Id'])) {
            await this.$store.dispatch('auth/updateCookies', {
              cookies: {
                csCookie: this.$cookies.get("__csc")
              }
            })
            await this.$router.push('/main');
          } else {
            await toggleBusy(false)
          }
        } else {
          await this.$store.dispatch("auth/updateAuth", {
            auth: response.data.content,
            isAuthenticated: false
          });
          await toggleBusy(false)
        }
      });
      let responseCaption = await AuthServices.getCaptions()
      if (responseCaption.status === 200 && responseCaption.data !== null) {
        await this.$store.dispatch("caption/setCaptions", responseCaption.data.content);
      }
    } catch (e) {
      console.log(e)
      await toggleBusy(false)
    } finally {
      await toggleBusy(false)
    }
  },
  methods: {
    getCaptions(label, label1, label2) {
      return getCaption(label, label1, label2)
    },
    async onLogin() {
      try {
        await toggleBusy(true)
        let response = await AuthServices.getCaptions()
        if (response.status === 200 && response.data.content !== null) {
          await this.$store.dispatch("caption/setCaptions", response.data.content);
        }
        await this.$store.dispatch('auth/updateCookies', {
          cookies: {
            csCookie: this.$cookies.get("__csc")
          }
        })
        await this.$store.dispatch('isValid', {isValid: true, isUpdated: true})
        let data = await AuthServices.authenticate({
          u: this.form.username,
          p: this.form.pwd
        })
        if (data.status === 200 && !isEmpty(data.data.content)) {
          await this.$store.dispatch("auth/updateAuth", {
            auth: data.data.content,
            isAuthenticated: !isEmpty(data.data?.content[0].t002Id)
          })

          Promise.all([
            await this.$store.dispatch('auth/updateCookies', {
              cookies: {
                csCookie: this.$cookies.get("__csc")
              }
            }),
          ]).then(async () => {
            this.$router.push('/main').then(() => {
              toggleBusy(false);
            });
          })
        } else {
          await toggleBusy(false)
          makeToast(this, getCaption('LABEL_LOGIN_ERROR'), 'danger')
        }
      } catch (err) {
        await toggleBusy(false)
        makeToast(this, getCaption('LABEL_LOGIN_ERROR'), 'danger')
      }

    },
  }
};
</script>
